import React from 'react';

// Context
import { useStartupStatus } from 'context/StartupStatusContext';
import { useTheme } from 'context/ThemeContext';

const SplashScreen = () => {

    // Theme Context
    const { theme } = useTheme();
    const { currentStatusMessage } = useStartupStatus();

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '18px',
                justifyContent: 'center',
                backgroundColor: theme.background,
                zIndex: 9999,
            }}
        >
            {/*
            <LogoLarge />
            */}

            {currentStatusMessage ? (
                <div
                    style={{
                        color: theme.foregroundMuted,
                        fontSize: '14px',
                        letterSpacing: '0.02em',
                        maxWidth: '420px',
                        padding: '0 24px',
                        textAlign: 'center',
                    }}
                >
                    {currentStatusMessage}
                </div>
            ) : null}
        </div>
    );
};

export default SplashScreen;
